let activeOptions = {};

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getStyleProperty(element, property) {
  return window.getComputedStyle(element).getPropertyValue(property);
}

/*
 * Shopify Common JS
 *
 */

if (typeof window.Shopify === "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options.method || "post";
  const params = options.parameters || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    const value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince() {
    const value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute("data-provinces");
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (let i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions(selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class QuantityCounter extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });
  }

  connectedCallback() {
    this.counterEl = this.querySelector(".js-counter-quantity");
    this.increaseBtn = this.querySelector(".js-counter-increase");
    this.decreaseBtn = this.querySelector(".js-counter-decrease");

    this.min = parseInt(this.counterEl.min) || 1;
    this.max = parseInt(this.counterEl.max) || 999;

    this.increaseBtn.addEventListener("click", this.onIncrease.bind(this));
    this.decreaseBtn.addEventListener("click", this.onDecrease.bind(this));
  }

  onIncrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (currentValue < this.max) {
      this.updateValue(currentValue + 1);
    }
  }

  onDecrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (this.dataset.cart) this.min = 0;
    if (currentValue > this.min) {
      this.updateValue(currentValue - 1);
    }
  }

  updateValue(value) {
    this.counterEl.value = value;

    this.counterEl.dispatchEvent(this.changeEvent);
  }
}

// Define the custom element
window.customElements.define("quantity-counter", QuantityCounter);

// without under functions main-password doesn't work

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function toggleTabindex(elements) {
  elements.forEach((el) => {
    const tabindex = el.getAttribute("tabindex");
    el.setAttribute("tabindex", tabindex === "0" ? "-1" : "0");
  });
}

function setTabindex(elements, tabindex) {
  elements.forEach((el) => {
    el.setAttribute("tabindex", tabindex);
  });
}

// Helper function to add multiple event listeners with the same handler
function addEventListeners(element, events, handler) {
  events.forEach((event) => element.addEventListener(event, handler));
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// Safari detection
const detectSafari = () => {
  const ua = navigator.userAgent;

  const isSafari =
    ua.includes("Safari") &&
    !ua.includes("Chrome") &&
    !ua.includes("CriOS") &&
    !ua.includes("FxiOS") &&
    !ua.includes("Edg");

  const isMacOS = ua.includes("Macintosh");

  if (isSafari && isMacOS) {
    document.documentElement.classList.add("is-safari-macos");
  }
};

// Custom video controls
document.addEventListener("DOMContentLoaded", () => {
  detectSafari();

  const BUTTON_SELECTOR = ".wt-hero-video__sound-toggle";
  const BUTTON_TOGGLE_CLASS = "wt-hero-video__sound-toggle--unmuted";

  document.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
    button.addEventListener("click", () => {
      const parent = button.parentElement;
      if (!parent) return;

      let video = null;

      video = Array.from(parent.children).find((el) => el.tagName === "VIDEO");

      if (!video) {
        const heroVideoContainer = Array.from(parent.children).find(
          (el) =>
            el.classList && el.classList.contains("hero--video-background"),
        );

        if (heroVideoContainer) {
          video = heroVideoContainer.querySelector("video");
        }
      }

      if (!video) {
        const grandparent = parent.closest("video-controls");
        console.log(grandparent);
        video = Array.from(grandparent.children).find(
          (el) => el.tagName === "VIDEO",
        );
      }

      if (!video) return;

      video.muted = !video.muted;
      button.classList.toggle(BUTTON_TOGGLE_CLASS, !video.muted);
    });
  });
});

/* Glogen homepage: 30-piece ritual presentation */
(() => {
  const updateRitual = () => {
    const orbit = document.querySelector('.gm__benefit-orbit');
    const beauty = document.querySelector('.gm__beauty-focus');
    if (!orbit || !beauty) return;

    if (orbit.nextElementSibling !== beauty) {
      orbit.insertAdjacentElement('afterend', beauty);
    }
    const kicker = beauty.querySelector('.gm__beauty-intro .gm__kicker');
    const heading = beauty.querySelector('.gm__beauty-intro h2');
    if (kicker) kicker.textContent = 'THE 30-DAY RITUAL';
    if (heading) heading.textContent = '30 pieces. One beautiful daily ritual.';

    const box = document.querySelector('.gm__flow-centre img');
    if (box) {
      const cleanImage = 'https://www.glogen.co/cdn/shop/files/glogen-30-day-variety-transparent-v3.png?v=1790087059&width=1200';
      if (box.src !== cleanImage) box.src = cleanImage;
      box.style.setProperty('background', 'transparent', 'important');
      box.style.setProperty('filter', 'drop-shadow(12px 18px 16px rgba(64, 42, 32, 0.22))', 'important');
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateRitual, { once: true });
  } else {
    updateRitual();
  }
  document.addEventListener('shopify:section:load', updateRitual);
})();


;(() => {
  const showGlowCalendar = () => {
    const step = Array.from(document.querySelectorAll('.gm__journey-flow .gm__flow-card')).find((card) => card.querySelector('summary small')?.textContent.includes('Days 02'));
    const image = step?.querySelector('.gm__flow-image img');
    if (!image || image.dataset.glogenCalendarReady === 'true') return;

    const dayTiles = Array.from({ length: 30 }, (_, index) => {
      const x = 130 + (index % 6) * 157;
      const y = 212 + Math.floor(index / 6) * 75;
      const day = String(index + 1).padStart(2, '0');
      return '<g><rect x="' + x + '" y="' + y + '" width="145" height="64" rx="10" fill="#fffdf9" stroke="#d9c7b7" stroke-width="1.5"/><text x="' + (x + 17) + '" y="' + (y + 41) + '" fill="#342b27" font-family="Georgia,serif" font-size="38">' + day + '</text><circle cx="' + (x + 112) + '" cy="' + (y + 32) + '" r="12" fill="none" stroke="#bc985d" stroke-width="2"/></g>';
    }).join('');

    const svg = [
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 650" width="1200" height="650">',
      '<defs><linearGradient id="back" x2="1" y2="1"><stop stop-color="#efdbd1"/><stop offset="1" stop-color="#c9ab9d"/></linearGradient><filter id="shadow"><feDropShadow dx="0" dy="16" stdDeviation="18" flood-color="#634438" flood-opacity=".2"/></filter></defs>',
      '<rect width="1200" height="650" fill="url(#back)"/>',
      '<circle cx="1095" cy="-10" r="175" fill="#f9eee6" opacity=".38"/><circle cx="75" cy="630" r="170" fill="#b68e7c" opacity=".18"/>',
      '<rect x="92" y="28" width="1016" height="592" rx="16" fill="#fffaf4" filter="url(#shadow)"/>',
      '<rect x="101" y="37" width="998" height="574" rx="10" fill="none" stroke="#c39c5d" stroke-width="2"/>',
      '<text x="130" y="86" fill="#b18a48" font-family="Georgia,serif" font-size="27" letter-spacing="5">GLO|GEN</text>',
      '<text x="130" y="145" fill="#292521" font-family="Georgia,serif" font-size="51">Your Glow Calendar</text>',
      '<text x="132" y="180" fill="#776c64" font-family="Arial,sans-serif" font-size="18" letter-spacing="2">ONE PIECE  ·  ONE DAY  ·  THIRTY DAYS</text>',
      '<path d="M130 192 H1070" stroke="#c6a66e" stroke-width="2"/>',
      dayTiles,
      '<text x="130" y="602" fill="#9d7b4e" font-family="Arial,sans-serif" font-size="15" letter-spacing="3">TICK YOUR MOMENT. MAKE IT YOURS.</text>',
      '</svg>'
    ].join('');

    image.src = 'https://cdn.shopify.com/s/files/1/0969/1172/0777/files/glogen-glow-calendar-30-day-corrected-v2.png?v=1791717321';
    image.alt = 'Glogen 30-day Glow Calendar with thirty daily spaces to mark';
    image.width = 1200;
    image.height = 650;
    image.dataset.glogenCalendarReady = 'true';
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showGlowCalendar, { once: true });
  } else {
    showGlowCalendar();
  }
  document.addEventListener('shopify:section:load', showGlowCalendar);
})();


;(() => {
  const showDayOneMoment = () => {
    const card = [...document.querySelectorAll('.gm__journey-flow .gm__flow-card')].find(item => item.querySelector('summary small')?.textContent.toUpperCase().includes('DAY 01'));
    const image = card?.querySelector('.gm__flow-image img');
    if (!image) return;
    image.src = 'https://cdn.shopify.com/s/files/1/0969/1172/0777/files/glogen-journey-day-01-unboxing-branded-v2.png?v=1791717318';
    image.alt = 'Opening a box of individually wrapped chocolates to begin the Glogen ritual';
    image.width = 1536;
    image.height = 1024;
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showDayOneMoment, { once: true });
  } else {
    showDayOneMoment();
  }
  document.addEventListener('shopify:section:load', showDayOneMoment);
const showDispatchEstimate = () => {
  const target = document.querySelector('.gm__preorder .gm__timeline li:last-child div');
  if (!target || target.querySelector('.gm__dispatch-estimate')) return;
  const dispatchDate = new Date();
  dispatchDate.setDate(dispatchDate.getDate() + 56);
  const formatted = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/London' }).format(dispatchDate);
  const note = document.createElement('p');
  note.className = 'gm__dispatch-estimate';
  note.textContent = 'Ordering today? Expected dispatch by ' + formatted + ' (within 8 weeks of your order). Delivery follows dispatch.';
  note.style.cssText = 'margin-top:14px;padding:12px 16px;border:1px solid rgba(255,255,255,.32);border-radius:12px;background:rgba(255,255,255,.09);color:#fff;font-size:13px;line-height:1.55';
  target.appendChild(note);
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showDispatchEstimate, { once: true }); else showDispatchEstimate();
document.addEventListener('shopify:section:load', showDispatchEstimate);
})();
